export const ACCEPTED_FILE_FORMATS_ARRAY = ['.jpg', '.jpeg', '.png', '.doc', '.docx', '.pdf'];

export const ACCEPTED_FILE_FORMATS = ACCEPTED_FILE_FORMATS_ARRAY.join(', ');

export const ACCEPTED_FILE_FORMATS_REGEX =
  /image\/(?:jpg|jpeg|png)|application\/(?:pdf|msword|vnd.openxmlformats-officedocument.wordprocessingml.document)/;
